import { InlineSVGModule } from 'ng-inline-svg-2';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxSpinnerModule } from 'ngx-spinner';
import { FlatpickrModule } from 'angularx-flatpickr';
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { setTheme } from 'ngx-bootstrap/utils';
import { NgxShimmerLoadingModule } from 'ngx-shimmer-loading';
import { SafeUrlPipe } from './pipes/safe-url.pipe';

@NgModule({
  declarations:[
    SafeUrlPipe
  ],
  imports: [
    InlineSVGModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    CommonModule,
    NgxSpinnerModule,
    NgbTooltipModule,
    FlatpickrModule.forRoot(),
    SweetAlert2Module.forRoot(),
    NgxShimmerLoadingModule,
  ],
  exports : [
    InlineSVGModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    NgxSpinnerModule,
    FlatpickrModule,
    NgbTooltipModule,
    NgxShimmerLoadingModule,
    SafeUrlPipe
  ]
})
export class SharedDataAccessUserModule {
  constructor(){
    setTheme('bs5');
  }
}
